import { useInvoicesItemFormPageContext } from "@web-src/modules/invoices/pages/InvoicesItemFormPage/context/useInvoicesItemFormPageContext";
import { FC, useEffect, useState } from "react";
import { cx } from "@jugl-web/utils";
import { InvoiceLineItem } from "@jugl-web/rest-api";
import { usePrevious } from "@web-src/utils/helper";

export const QuantityCell: FC<{
  item: InvoiceLineItem;
  idx: number;
}> = ({ item, idx }) => {
  const { itemsField, customErrors, setCustomErrors } =
    useInvoicesItemFormPageContext();
  const [displayQuantity, setDisplayQuantity] = useState(
    item.qty?.toString() || ""
  );

  const previouseQuantity = usePrevious(item.qty);
  useEffect(() => {
    if (previouseQuantity !== item.qty) {
      setDisplayQuantity(item.qty?.toString() || "");
    }
  }, [item.qty, previouseQuantity]);

  const setQuantity = (value: string) => {
    const setZero = () => {
      itemsField.update(idx, {
        ...item,
        qty: 0,
      });
      setDisplayQuantity("0");
    };
    if (value === "") {
      setZero();
    } else {
      const numValue = Number(value);
      if (numValue <= 0 || Number.isNaN(numValue)) {
        setZero();
      } else {
        itemsField.update(idx, {
          ...item,
          qty: numValue,
        });
      }
    }
  };

  const handleUpdateQuantity = (event: React.ChangeEvent<HTMLInputElement>) => {
    const numericValue = event.target.value.replace(/[^\d]/g, "");
    const truncatedValue = numericValue.slice(0, 8);

    setDisplayQuantity(truncatedValue);
    setQuantity(truncatedValue);

    if (customErrors.quantity?.[idx]) {
      const errorsCopy = { ...customErrors };
      if (errorsCopy.quantity) {
        delete errorsCopy.quantity[idx];
        if (Object.keys(errorsCopy.quantity).length === 0) {
          delete errorsCopy.quantity;
        }
      }
      setCustomErrors(errorsCopy);
    }
  };

  const normalizeQuantity = () => {
    // Remove leading zeros
    if (displayQuantity.startsWith("0") && displayQuantity.length > 1) {
      const normalizedValue = displayQuantity.replace(/^0+/, "");
      setDisplayQuantity(normalizedValue);
      setQuantity(normalizedValue);
    } else {
      setQuantity(displayQuantity);
    }
  };

  const hasQuantityError = !!customErrors.quantity?.[idx];

  return (
    <div
      className={cx("flex items-center gap-2 text-sm hover:bg-grey-100", {
        "border border-solid border-red-500": hasQuantityError,
      })}
    >
      <input
        type="number"
        min={0}
        maxLength={8}
        onKeyDown={(e) => {
          const notAllowedCharacters = ["e", "E", "+", "-", "."];
          if (notAllowedCharacters.includes(e.key)) {
            e.preventDefault();
          }
        }}
        className="h-14 w-full border border-solid border-transparent bg-transparent px-4 text-sm font-medium text-dark-800 focus:border-primary-200 focus:outline-none"
        value={displayQuantity}
        onChange={handleUpdateQuantity}
        onBlur={normalizeQuantity}
      />
    </div>
  );
};
